import {
  Component,
  DestroyRef,
  Input,
  OnInit,
  WritableSignal,
  inject,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Observable } from 'rxjs';

import { MenuItem, NavigationMenuService } from '@fcom/common';
import {
  CmsContent,
  CmsContentType,
  CmsFormType,
  CmsTaxonomyGeneral,
  CmsTemplate,
  CmsViewType,
  PageViewType,
} from '@fcom/core-api';
import { LoaderTheme } from '@fcom/ui-components/components/loader/enums';

@Component({
  selector: 'cms-editorial-main-page',
  templateUrl: './cms-editorial-main-page.component.html',
  styleUrls: ['./cms-editorial-main-page.component.scss'],
  animations: [
    trigger('fadeIn', [state('void', style({ opacity: 0 })), transition(':enter', [animate('0.5s ease-in')])]),
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CmsEditorialMainPageComponent implements OnInit {
  private navigationMenuService = inject(NavigationMenuService);
  private destroyRef = inject(DestroyRef);

  @Input()
  template$: Observable<CmsTemplate>;

  @Input()
  hasContent = false;

  activeNaviSection$: Observable<MenuItem>;
  titleAsSpan: WritableSignal<boolean> = signal<boolean>(false);

  public readonly DOCTYPE: typeof CmsContentType = CmsContentType;
  public readonly VIEWTYPE: typeof CmsViewType = CmsViewType;
  public readonly FORMTYPE: typeof CmsFormType = CmsFormType;
  public readonly PAGETYPE: typeof PageViewType = PageViewType;
  protected readonly LoaderTheme = LoaderTheme;

  constructor() {
    this.activeNaviSection$ = this.navigationMenuService.activeNaviSection;
  }

  ngOnInit(): void {
    this.template$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((template: CmsTemplate): void => {
      this.titleAsSpan.set(
        template?.header?.some((item: CmsContent): boolean =>
          item?.subjectTaxonomyTags?.includes(CmsTaxonomyGeneral.EDITORIAL_TITLE_AS_SPAN)
        )
      );
    });
  }
}
